// background patterns
// - defined in @common/css/patterns.css
// - used in @math/MathDrill.vue for drill backgrounds
export const backgrounds = [
  'bg-lined-paper',
  'bg-blue-grid',
  // 'bg-cross-dots',
  'bg-tablecloth',
  'bg-checkerboard',
  'bg-honeycomb',
  'bg-polkadot',
  'bg-zigzag',
  'bg-arrows',
  // 'bg-waves',
  'bg-hearts',
  'bg-steps',
  'bg-weave'
]

// images for add/subtract with pictures
// - stored under @/static/
// - downloaded from https://icons8.com/icon/set/animals/color
export const pictures = [
  '/static/picture-bird-48.png',
  '/static/picture-crab-48.png',
  '/static/picture-dolphin-48.png',
  '/static/picture-hamster-48.png',
  '/static/picture-kangaroo-48.png',
  '/static/picture-cat-48.png',
  '/static/picture-ladybug-48.png',
  '/static/picture-peacock-48.png',
  '/static/picture-pig-48.png',
  '/static/picture-starfish-48.png',
  '/static/picture-butterfly-48.png',
  '/static/picture-whale-48.png'
]



// WEBPACK FOOTER //
// ./src/common/js/constants.js